<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/order/details/', projectId, orderId]">Zurück zum Auftrag</a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/orders']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2 class="mb1em">PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Order {{ projectId }}.0002.{{ orderId }} bearbeiten</h2>
  <app-order-form
    *ngIf="orders"
    [projectId]="projectId"
    [orderId]="orderId"
    [jobId]="jobId"
    [ordersData]="orders[0]"
    [isUpdateMode]="true">
  </app-order-form>
</main>

<pre *ngIf="devMode" class="datepicker-output">
  <p>Orders:</p>
  {{ orders | json }}
</pre>
